var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOccupancyEmpty = function SvgOccupancyEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 14-.155-1.443a2.862 2.862 0 0 0-5.69 0L1 14M15 14l-.155-1.443a2.862 2.862 0 0 0-5.69 0L9 14"
  }))));
};
export default SvgOccupancyEmpty;